/* eslint-disable no-undef */
const apiKeyHK = process.env.REACT_APP_STRIPE_API_KEY_HK;
export const stripeHK = Stripe(apiKeyHK);

const apiKeyUK = process.env.REACT_APP_STRIPE_API_KEY_UK;
export const StripeUK = Stripe(apiKeyUK);

export default stripeHK; // Previously, we had and use HK account as the primary
